import LessonItemCardSession from 'core/lite/views/LessonViewV2/LessonItemCard/LessonItemCardSession';
import { isImage } from 'core/utils/utils';
import PropTypes from 'prop-types';
import React from 'react';
import Icon from 'ui/atoms/Icon/Icon';
import IconBubble from 'ui/molecules/IconBubble/IconBubble';

function MaterialPreviewHead({ contentLang, material, sessions, t }) {
  return (
    <div className="material-preview-head mb-2">
      {material.icon && isImage(material.icon) ? (
        <div className="lesson-item-card__left-icon-img" style={{ backgroundImage: `url(${material.icon})` }}></div>
      ) : (
        <IconBubble name={material.icon} background="alpha" color="primary" size="md" />
      )}
      <div className="material-preview-head__texts ml-3">
        <div className="lesson-element-item__type">{material.typeName}</div>
        <div className="lesson-element-item__name" lang={contentLang}>
          {material.name}
        </div>

        <div className="d-flex align-items-center1 mt-2">
          <div className="lesson-item-card__info-right mr-2">
            <LessonItemCardSession sessions={sessions} isTeacherOnly={!!material.content_is_teacher_only} t={t} />
          </div>

          {!!material.content_is_evaluable && (
            <span className="evaluable-tag mr-2">
              <Icon name="star-evaluable" size="sm" />
              <span className="ml-1">{t('assigments:Evaluation')}</span>
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

MaterialPreviewHead.propTypes = {
  contentLang: PropTypes.string,
  material: PropTypes.shape({
    content_is_evaluable: PropTypes.number,
    content_is_teacher_only: PropTypes.bool,
    icon: PropTypes.string,
    name: PropTypes.string,
    typeName: PropTypes.string,
  }).isRequired,
  sessions: PropTypes.array,
  t: PropTypes.func.isRequired,
};

MaterialPreviewHead.defaultProps = {
  sessions: [],
};

export default MaterialPreviewHead;
